module.exports = __webpack_public_path__ + "img/1565762334.42c26176.jpg";